import React from 'react';
import { motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
const bullets = ['Terminás agotado después de ciertas conversaciones', 'Sobrepensás demasiado', 'Vivís evitando conflictos', 'Absorbés tensión constantemente', 'Sentís culpa cuando ponés límites', 'Caminás sobre huevos con algunas personas', 'Te cuesta decir que no sin sentirte culpable', 'Tu energía mental se agota en discusiones que no te suman'];
export function IdentificationSection() {
  return <section className="w-full py-20 md:py-28 px-4" data-id="element-202" data-mp="1p76mhau9p5ua">
      <div className="max-w-4xl mx-auto" data-id="element-203" data-mp="1p9sv7dsw9re3">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-204" data-mp="1u69h01cmfto0">
          <h2 className="font-serif font-bold text-3xl sm:text-4xl md:text-5xl text-ink leading-[1.1] mb-6" data-id="element-205" data-mp="3wg1ey4rfuer">
            ¿Sentís que ciertas personas te{' '}
            <span className="font-serif-italic text-rose font-normal" data-id="element-206" data-mp="izbqxnfyi3e">
              consumen mentalmente
            </span>
            ?
          </h2>
          <p className="text-ink-soft text-base md:text-lg max-w-2xl mx-auto leading-relaxed" data-id="element-207" data-mp="3rnz187srl6t2">
            Muchas veces el verdadero agotamiento no viene del trabajo. Viene de
            convivir constantemente con personas difíciles, manipuladoras o
            emocionalmente agotadoras.
          </p>
          <p className="text-rose font-serif-italic text-xl md:text-2xl mt-5" data-id="element-208" data-mp="ebf6zca3pbtr">
            No es falta de voluntad. Es falta de un sistema.
          </p>
        </motion.div>

        <div className="grid sm:grid-cols-2 gap-3 mb-12" data-id="element-209" data-mp="9c2nn1ifumvx">
          {bullets.map((b, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: -8
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.05,
          duration: 0.4
        }} className="flex items-start gap-3 bg-white border border-line rounded-2xl p-4 md:p-5 shadow-sm" data-id="element-210" data-mp="2z2xsv5pbxjuz" data-mpi={i}>
              <span className="flex-shrink-0 w-7 h-7 rounded-full bg-rose/10 flex items-center justify-center mt-0.5" data-id="element-211" data-mp="12fddyrocmia3">
                <XIcon className="w-4 h-4 text-rose" strokeWidth={3} data-id="element-212" data-mp="1763iy3sv4j49" />
              </span>
              <span className="text-ink text-sm md:text-base" data-id="element-213" data-mp="teyqblnwwr3f">{b}</span>
            </motion.div>)}
        </div>

        <motion.blockquote initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-white border border-line rounded-3xl p-8 md:p-12 text-center shadow-sm" data-id="element-214" data-mp="yebdy8mly272">
          <p className="font-serif-italic text-2xl md:text-3xl leading-relaxed text-ink" data-id="element-215" data-mp="tjn3lcc5fzp">
            "No siempre podés elegir con quién convivir. Pero sí podés aprender
            a proteger tu{' '}
            <span className="text-rose font-semibold not-italic" data-id="element-216" data-mp="9r2d744u6kig">
              tranquilidad mental
            </span>
            ."
          </p>
        </motion.blockquote>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mt-10" data-id="element-217" data-mp="jprvgy0na6z8">
          <p className="font-serif-italic text-rose text-xl md:text-2xl" data-id="element-218" data-mp="17h6xsqsf8oah">
            ¿Y si este fuera el último día que postergás tu paz mental?
          </p>
        </motion.div>
      </div>
    </section>;
}